<template>
  <el-card class="box-card" body-style="padding: 0px">
    <div slot="header" class="clearfix">
      <el-row :gutter="10" slot="header" class="clearfix" style="display: flex; justify-content: space-between;">
        <el-col :sm="12" :xs="24" style="display: flex; justify-content: center;flex-direction: column;">
          <label class="card-title text-left">サブスク会員</label>
        </el-col>
        <el-col :sm="12" :xs="24" style="text-right">
          <el-button 
            class="btn-plus" style="float: right" type="success" icon="el-icon-plus" 
            @click="addNewSubscription" 
            v-if="permission.can('write', 'membershipsubscription')">
            新規登録する
          </el-button>
<!--          <el-button class="btn-plus" style="float: right" type="success" @click="filterByStatus('in_effect')">-->
<!--            契約中一覧を表示-->
<!--          </el-button>-->
<!--          <el-button class="btn-plus" style="float: right" type="success" @click="filterByStatus('pending')">-->
<!--            休会中一覧を表示-->
<!--          </el-button>-->
<!--          <el-button class="btn-plus" style="float: right" type="success" @click="filterByStatus('discontinued')">-->
<!--            退会済み一覧を表示-->
<!--          </el-button>-->
        </el-col>
      </el-row>
    </div>
    <div class="clearfix">
      <el-table :data="membershipSubscriptions" border fit highlight-current-row style="width: 100%" @row-click="rowClicked" @sort-change="handleSort" empty-text="該当結果が見つかりません。"
      >
        <el-table-column
          prop="member_code"
          label="会員番号"
          min-width="130px"
        >
        </el-table-column>
        <el-table-column
          prop="subscription_package.name"
          label="会員プラン"
          min-width="130px"
        >
        </el-table-column>
        <el-table-column
          prop="clinic_customer_note.full_name"
          min-width="130px"
          label="名前"
        >
        </el-table-column>
        <el-table-column
          prop="clinic.clinic_name"
          min-width="130px"
          label="店舗名"
        >
        </el-table-column>
        <el-table-column
          prop="total_point"
          min-width="130px"
          label="保有ポイント"
        >
          <template slot-scope="props">
            {{ props.row.total_point && props.row.total_point.toLocaleString() }}
          </template>>
        </el-table-column>
        <el-table-column
          prop="contract_status"
          min-width="130px"
          sortable="custom"
          label="会員ステータス"
        >
          <template slot-scope="props">
            {{ subscriptionContractStatuses.find((item) => item.key === props.row.contract_status).value }}
          </template>>
        </el-table-column>
        <el-table-column
          prop="last_treatment_day"
          min-width="130px"
          sortable="custom"
          label="最終来店"
        >
        </el-table-column>
        <el-table-column
          prop="nearest_expired_date"
          min-width="130px"
          sortable="custom"
          label="直近有効期限"
        >
        </el-table-column>
<!--        <el-table-column-->
<!--            v-if="queryMembershipSubscription.contract_status === 'pending'"-->
<!--            prop="pending_date"-->
<!--            min-width="130px"-->
<!--            sortable="custom"-->
<!--            label="休会開始日"-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            v-if="queryMembershipSubscription.contract_status === 'pending'"-->
<!--            prop="end_pending_date"-->
<!--            min-width="130px"-->
<!--            sortable="custom"-->
<!--            label="休会終了日"-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            v-if="queryMembershipSubscription.contract_status === 'discontinued'"-->
<!--            prop="start_date"-->
<!--            min-width="130px"-->
<!--            sortable="custom"-->
<!--            label="契約日"-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--            v-if="queryMembershipSubscription.contract_status === 'discontinued'"-->
<!--            prop="discontinued_date"-->
<!--            min-width="130px"-->
<!--            sortable="custom"-->
<!--            label="解約日"-->
<!--        >-->
<!--        </el-table-column>-->
      </el-table>
    </div>
  </el-card>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from "vuex";
  import permissionService from "../../services/permission_service";

  export default {
    data() {
      return {
        permission: permissionService
      }
    },
    computed: {
      ...mapGetters(['membershipSubscriptions', 'newSubscription', 'queryMembershipSubscription','membershipSubscriptionIsEdit', 'subscriptionContractStatuses', 'currentClinic']),
    },
    methods: {
      ...mapMutations('membership_subscription', ['SET_IS_SUBSCRIPTION_VISIBLE', 'SET_MEMBERSHIP_SUBSCRIPTION_IS_EDIT', 'SET_EDIT_MEMBERSHIP_SUBSCRIPTION', 'SET_QUERY_MEMBERSHIP_SUBSCRIPTION']),
      ...mapActions('clinic_customer_note', ['fetchClinicCustomerNotes']),
      ...mapActions('subscription_package', ['fetchModalSubscriptionPackages']),
      ...mapActions('membership_subscription', ['fetchMembershipSubscriptions']),
      async addNewSubscription() {
        this.SET_EDIT_MEMBERSHIP_SUBSCRIPTION(this.newSubscription)
        this.SET_IS_SUBSCRIPTION_VISIBLE(true)
        this.SET_MEMBERSHIP_SUBSCRIPTION_IS_EDIT(false)
        if (this.permission.can('write_all', 'membershipsubscription')) {
          this.fetchModalSubscriptionPackages({ type: 'reset' })
        } else if (this.permission.can('write', 'membershipsubscription')) {
          await this.fetchClinicCustomerNotes({clinic_id: this.currentClinic.id})
          this.fetchModalSubscriptionPackages({ clinic_id: this.currentClinic.id })
        }
        document.body.classList.add('modal-open')
      },
      rowClicked(row) {
        this.SET_MEMBERSHIP_SUBSCRIPTION_IS_EDIT(true)
        this.SET_IS_SUBSCRIPTION_VISIBLE(true)
        this.SET_EDIT_MEMBERSHIP_SUBSCRIPTION(row)
        document.body.classList.add('modal-open')
      },
      handleSort(props) {
        if (!props.order) {
          return
        }

        const order = props.order === 'descending' ? props.order.slice(0, 4) : props.order.slice(0, 3)
        this.SET_QUERY_MEMBERSHIP_SUBSCRIPTION({ order: `${props.prop} ${order}` })
        this.fetchMembershipSubscriptions()
      },
      filterByStatus(status) {
        this.queryMembershipSubscription.contract_status = status
        this.queryMembershipSubscription.order = ''
        this.fetchMembershipSubscriptions()
      },
    }
  }
</script>
<style>
  th .cell, .el-table .sort-caret.ascending {
    color: #51cbce;
  }
</style>
